module.exports = __webpack_public_path__ + "img/trial1-4.7791473a.png";